import {
  Button,
  ButtonSize,
  IconButton,
  IconButtonSize
} from "shared/components";
import { ArrowLeft, XClose } from "untitledui-js-base";
import { StepNames } from "../constants";

export const IframeLayout = ({
  activeStepName,
  setActiveStepName,
  children,
  stepNames,
  setOpen,
  noBack,
  goBack
}: {
  activeStepName: string;
  setActiveStepName: (stepName: string) => void;
  children: React.ReactNode;
  stepNames: string[];
  setOpen: (value: boolean) => void;
  noBack?: boolean;
  goBack?: () => void;
}) => {
  return (
    <div className="flex-1">
      <div className="h-[72px] border-b border-alpha-100 flex items-center justify-between px-2">
        {noBack || activeStepName === stepNames[0] ? (
          // Leaving this here to preserve the layout space
          <div />
        ) : (
          <Button
            borderLess
            size={ButtonSize.SM}
            onClick={() => {
              if (goBack) goBack();
              else {
                const currentIdx = stepNames.indexOf(activeStepName!);
                const nextIdx = currentIdx - 1;

                if (nextIdx >= 0) setActiveStepName(stepNames[nextIdx]);
              }
            }}
            Icon={ArrowLeft}
          >
            Back
          </Button>
        )}
        <h1 className="text-base font-bold text-content-1000 text-center -translate-x-6">
          {StepNames[activeStepName || ""]}
        </h1>

        <IconButton
          Icon={XClose}
          borderLess
          size={IconButtonSize.SM}
          onClick={() => {
            setOpen(false);
          }}
        />
      </div>
      {children}
    </div>
  );
};
